import React from "react";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({ component: Component, isAuthed, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: `${process.env.REACT_APP_URL_ROOT}login`,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
